import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import FooterCrud from '../footer/FooterCrud';
import ModalAlerta from '../modal/ModalAlerta';
import Alerta from '../alert/Alerta';
import PreloadContent from '../preload/PreloadContent';
import Sucesso from '../alert/Sucesso';

import './Content.css';

class ContentCadastro extends AbstractComponent {
    showExtraComponent() {
        if(this.props.component === undefined) {
            return ;
        }

        return this.props.component;
    }   

    show() {
        if(this.props.preload) 
            return ;

        return (
            <Fragment>
                <Sucesso 
                    exibir={this.props.sucesso} 
                    texto={this.props.textoSucesso}
                    timeOut={5}
                    onTimeOut={() => this.props.onSucesso()}
                />

                <main>                        
                    <div className="col-md-12
                                    col-sm-12
                                    col-lg-12
                                    col-xs-12">
                        <h1 className="mt-4 mb-4">
                            {this.props.title}
                        </h1>    
                    </div>

                    {this.showExtraComponent()}                    

                    <div className={"container-fluid container-custom " + this.props.className}>
                        <Alerta
                            exibir={this.props.erro.code !== 0}
                            texto={this.props.erro.message}
                        />
                        
                        {this.props.children}                        
                    </div>
                </main>

                <FooterCrud
                    history={this.props.history}                    
                    salvar={this.props.salvar}
                    salvarVisible={this.props.salvarVisible}
                    onSalvar={this.props.onSalvar}  
                    componentFooterCrud={this.props.componentFooterCrud}    
                    
                    route={(route) => this.props.route(route)}
                />                 
            </Fragment>
        )
    }

    fechar() {
        if(this.props.fecharModal !== undefined)
            this.props.fecharModal();
    }

    render() {
        return (
            <Fragment>
                <ModalAlerta
                    show={this.props.modalErroMsg.code !== 0}
                    texto={this.props.modalErroMsg.message}
                    
                    fechar={() => this.fechar()}
                />

                <PreloadContent show={this.props.preload} />
                
                {this.show()}
            </Fragment>
        )
    }
}

ContentCadastro.defaultProps = {
    preload: false,
    
    sucesso: false,

    textoSucesso: '',

    title: '',

    history: '',

    modalErroMsg: {
        message: '',
        code: 0
    }, 

    salvar: {
        disabled: true,
        name: 'Salvar'
    },

    salvarVisible: true,

    erro: {
        message: '',
        code: 0
    }
}

export default ContentCadastro;